<template>
    <div class="expenditure-request-component container mb-5">
        <wizard :stepsCount="stepsCount" :disable-next="wizard.disableNext || formHasError" :current-index="wizard.currentIndex" v-if="!isDone">
            <template #header>
                <wizard-header :title="wizardTitle" :current-step="wizard.currentIndex + 1" :steps-count="stepsCount"/>
            </template>

            <template #steps>
                <wizard-step v-if="wizard.currentIndex === 0">
                    <expenditure-request-type-step/>
                </wizard-step>
                <wizard-step v-if="wizard.currentIndex === 1">
                    <expenditure-request-items-step v-if="expenditureRequest.expenditure_id === 4"/>
                    <expenditure-request-form-step v-else/>
                </wizard-step>
                <wizard-step v-if="wizard.currentIndex === 2">
                    <expenditure-request-form-step/>
                </wizard-step>
            </template>

            <template #footer>
                <button class="btn btn--sm btn--round btn-white" @click="prevSlide" v-if="wizard.currentIndex">Назад</button>
                <button class="btn btn--sm btn--round btn--color1" @click="nextSlide" :disabled="disableNext">{{ stepsCount > wizard.currentIndex + 1 ? 'Дальше' : 'Отправить' }}</button>
            </template>
        </wizard>
        <div class="mt-5" v-else>
            <submit-success text="Ваш запрос успешно отправлен! Ожидайте уведомление о результате рассмотрения." btn-text="Перейти в Финансовый отчет" :btn-url="`volunteer/${user.id}/finance-report`"></submit-success>
        </div>
    </div>
</template>

<script>
import Wizard from "../Wizard/Wizard";
import WizardStep from "../Wizard/WizardStep";
import WizardHeader from "../Wizard/WizardHeader";

import ExpenditureRequestTypeStep from "./ExpenditureRequestTypeStep";
import ExpenditureRequestItemsStep from "./ExpenditureRequestItemsStep";
import ExpenditureRequestFormStep from "./ExpenditureRequestFormStep";
import SubmitSuccess from "../chunk/SubmitSuccess";

import {mapGetters, mapMutations} from "vuex";
import {paginationScrollTo} from "../helpers/helpers";

export default {
    name: "ExpenditureRequestCreate",
    components: {Wizard, WizardStep, WizardHeader, ExpenditureRequestTypeStep, ExpenditureRequestItemsStep, ExpenditureRequestFormStep, SubmitSuccess},
    data() {
        return {
            isDone: false,
            wizard: {
                currentIndex: 0,
            }
        }
    },
    computed: {
        ...mapGetters({
            expenditureRequest: 'getterExpenditureRequest',
            formHasError: 'getterFormHasError',
            user: 'getUserData'
        }),
        disableNext() {

            // Если это второй шаг если это мед - значит проверка на контрагента
            if (this.wizard.currentIndex === 1 && this.expenditureRequest.expenditure_id === 4 && !this.expenditureRequest.contractor_id) {
                return true;
            }

            // Проверяем последний шаг
            if (this.wizard.currentIndex === (this.expenditureRequest.expenditure_id === 4 ? 2 : 1) && !this.expenditureRequest.target_pet_id && !this.expenditureRequest.target_project_id) {
                return true;
            }

            return false
        },

        stepsCount() {
            if (this.expenditureRequest.expenditure_id !== 4) {
                return 2;
            }
            return 3;
        },
        wizardTitle() {
            if (this.wizard.currentIndex === 0) {
                return "Выбор статью расхода";
            } else if (this.wizard.currentIndex === 1) {
                if (this.expenditureRequest.expenditure_id === 4) {
                    return "Выберите исполнителя";
                }
            }

            return "Указание суммы затрат";
        }
    },
    mounted() {
        console.log(this)
    },
    methods: {
        ...mapMutations({
            setSubmitNextClick: 'setterSubmitNextClick',
            resetState: 'resetState',
            updateExpenditureRequest: 'setterExpenditureRequestParam'
        }),
        prevSlide() {
            this.animation = 'slide-back';


            if (this.wizard.currentIndex - 1 >= 0) {
                this.wizard.currentIndex--;

                if(this.wizard.currentIndex === 0 && this.expenditureRequest.expenditure_id === 4) {
                    this.updateExpenditureRequest({key: 'contractor_id', data: ''})
                }
            }
        },
        nextSlide() {
            this.animation = 'slide';

            this.setSubmitNextClick();

            this.$nextTick(() => {
                if (this.wizard.currentIndex + 1 < this.stepsCount) {
                    this.wizard.currentIndex++;
                } else {
                    if (this.formHasError) {
                        return false;
                    } else {
                        console.log('Отправляем')
                        this.submit()
                    }
                }
            })
        },
        submit() {
            let requestData = new FormData();
            requestData.append('expenditure_id', this.expenditureRequest.expenditure_id);
            requestData.append('type', this.expenditureRequest.type);
            requestData.append('purpose', this.expenditureRequest.purpose);
            requestData.append('amount', this.expenditureRequest.amount);
            requestData.append('target_pet_id', this.expenditureRequest.target_pet_id);
            requestData.append('target_project_id', this.expenditureRequest.target_project_id);
            requestData.append('contractor_id', this.expenditureRequest.contractor_id);

            if (this.expenditureRequest.images.length) {
                this.expenditureRequest.images.forEach(function (imageFile) {
                    requestData.append('images[]', imageFile);
                });
            }

            axios.post('/api/expenditure-requests', requestData, {
                header: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                paginationScrollTo('.wizard')

                response = response.data;

                if (response.success) {
                    this.isDone = true;
                    this.resetState()
                }
            }).catch(err => {
                err = err.response.data
                if (!err.success) {
                    console.log(err)
                }
            })

        }
    }
}
</script>

<!--Общие стили для вложенных в wizard компонентов-->
<style lang="scss">
.expenditure-request-component {
    .btn-white {
        background: #fff;
        color: #0674ec;
        border: 1px solid #0674ec;
    }

    .er-card {
        background: #FEFAFA;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
        padding: 36px 46px 40px 46px;
        border: 2px solid transparent;
        box-sizing: border-box;

        &:hover,
        &.selected {
            border: 2px solid #2E76E4;
        }

        &.selected {
            background: #EAF1FC;
        }

        &.er-card-sm {
            padding: 24px 40px 24px 24px;
        }

        &.er-card-xs {
            padding: 12px 20px 12px 12px;
        }
    }

    label {
        font-size: 14px;
    }

    textarea,
    input {
        background: #FEFAFA;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
        border-radius: 7px;
        font-size: 14px;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
}
</style>
